import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoRegrasValidacao } from 'pages/compra/configuracao-pedido/types';

/**
 * Formata os dados iniciais das regras de validação.
 */
export const formatInitialRegrasValidacaoData = (data: ConfigPedidoRegrasValidacao) => {
    if (typeof data.peOferta !== 'number') {
        data.peOferta = 0;
        data.fgUtilizaDescontoCadastroLoja = true;
    }

    if (typeof data.vlBaseFreteGratis === 'number') {
        data.fgUtilizaVlBaseFreteGratis = true;
    }

    return data;
};

export function useQueryRegrasValidacao() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoRegrasValidacao>({
        queryKey: ['config-pedido-regras-validacao', id],
        queryFn: () =>
            requestListagem({ url: `/gestao/configpedidoregravalidacao/configpedido/${id}` }).then((res) =>
                formatInitialRegrasValidacaoData(res.data),
            ),
    });
}
